module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/playerHeadshots/mlb/survive-51a3167c1ae004c94dcf112a853fbf1b.svg";